import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, Subscription } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpAppRoleService } from '../../../service/http-app-role.service';
import { AppRoleDto } from '../../../service/dto';


@Component({
	selector: 'app-role-edit',
	standalone: false,
	templateUrl: './role-edit.component.html',
	styleUrl: './role-edit.component.scss'
})
export class RoleEditComponent {
	roleId?: number;
	role?: AppRoleDto;
	roleForm!: FormGroup;

	loading = false;
	submitting = false;
	subscription = new Subscription();
	mode: 'New' | 'Edit' = 'New';

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private roleService: HttpAppRoleService,
		private activatedRoute: ActivatedRoute,
		private messageService: NzMessageService) {
	}
	ngOnInit(): void {
		this.subscription.add(
			this.activatedRoute.paramMap.subscribe(params => {
				const roleId = params.get('roleId');
				if (roleId) {
					this.roleService.get(+roleId).subscribe(result => {
						this.initEdit(result);
					});
				} else {
					this.initNew();
				}
			})
		);
	}
	initNew() {
		this.mode = 'New';
		this.roleId = 0;
		this.roleForm = this.fb.group({
			name: ['', Validators.required],
			description: ['', Validators.required],
		});
	}
	initEdit(input: AppRoleDto) {
		this.mode = 'Edit';
		this.roleId = input.id;
		this.role = input;
		this.roleForm = this.fb.group({
			name: [input.name, Validators.required],
			description: [input.description, Validators.required],
		});
	}

	doSubmit() {
		const payload: AppRoleDto = {
			id: 0,
			createdAt: new Date(),
			name: this.roleForm.get('name')?.value,
			description: this.roleForm.get('description')?.value,
			permissions: [],
			agents: this.role?.agents ?? [],
			hashCode: 0
		};
		if (this.mode == 'New') {
			this.roleService.createRole(payload).subscribe(result => {
				this.messageService.info('Role created');
				this.initEdit(result);
			});
		} else {
			this.roleService.editRole(this.roleId!, payload).subscribe(result => {
				this.messageService.info('Role updated');
				this.initEdit(result);
			});
		}
	}
}
